import { SET_WAITING_REQUESTS } from "./swConstants";
import { setValue } from "../../lib/immutable_wrapper";

const initialState = {
    waitingRequests: [],
};

export function serviceWorker(state = initialState, action) {
    switch (action.type) {
        case SET_WAITING_REQUESTS:
            return setValue(state, ["waitingRequests"], action.waitingRequests);
        default:
            return state;
    }
}
